module.exports = __webpack_public_path__ + "images/emoji/pig2.194ae28f22b7ab582c5a.png";